/**
 * Handler para el layout horizontal de las product cards
 * Maneja la funcionalidad de cantidad y actualización de precios
 */

document.addEventListener('DOMContentLoaded', function() {
  initHorizontalCards();
  setupCartButtons();
});

function initHorizontalCards() {
  // Seleccionar todas las cards
  const cards = document.querySelectorAll('.trending-products__card');
  
  cards.forEach(card => {
    setupQuantityControls(card);
    setupVariantSelector(card);
  });
}

/**
 * Configura los botones de agregar al carrito y comprar ahora
 */
function setupCartButtons() {
  // Botones "Add to Cart" (vertical y horizontal)
  const addToCartButtons = document.querySelectorAll(
    '.trending-products__btn--cart-horizontal'
  );
  
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.getAttribute('data-variant-id');
      const productTitle = this.getAttribute('data-product-title');
      const card = this.closest('.trending-products__card');
      const quantityInput = card.querySelector('.quantity-input');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      if (variantId) {
        addToCart(variantId, quantity, productTitle, button);
      }
    });
  });
  
  // Botones "Buy Now" (vertical y horizontal)
  const buyNowButtons = document.querySelectorAll(
    '.trending-products__btn--buy-horizontal'
  );
  
  buyNowButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.preventDefault();
      const variantId = this.getAttribute('data-variant-id');
      const productUrl = this.getAttribute('data-product-url');
      const card = this.closest('.trending-products__card');
      const quantityInput = card.querySelector('.quantity-input');
      const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
      
      if (variantId) {
        buyNow(variantId, quantity, productUrl);
      }
    });
  });
}

/**
 * Agrega producto al carrito
 */
function addToCart(variantId, quantity, productTitle, button) {
  // Deshabilitar botón mientras se procesa
  const originalText = button.innerHTML;
  button.disabled = true;
  button.innerHTML = 'ADDING...';
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    console.log('Product added to cart:', data);
    
    // Feedback visual
    button.innerHTML = '✓ ADDED';
    button.style.background = '#4CAF50';
    
    // Actualizar contador del carrito si existe
    updateCartCount();
    
    // Restaurar botón después de 2 segundos
    setTimeout(() => {
      button.disabled = false;
      button.innerHTML = originalText;
      button.style.background = '';
    }, 2000);
    
    // Opcional: Mostrar notificación
    showNotification(`${productTitle} added to cart!`);
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    button.disabled = false;
    button.innerHTML = originalText;
    alert('Error adding product to cart. Please try again.');
  });
}

/**
 * Comprar ahora (agregar al carrito y redirigir)
 */
function buyNow(variantId, quantity, productUrl) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantId,
      quantity: quantity
    })
  })
  .then(response => response.json())
  .then(data => {
    // Redirigir al checkout
    window.location.href = '/checkout';
  })
  .catch(error => {
    console.error('Error with buy now:', error);
    alert('Error processing your purchase. Please try again.');
  });
}

/**
 * Actualiza el contador del carrito
 */
function updateCartCount() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {
      const cartCountElements = document.querySelectorAll('.cart-count, [data-cart-count]');
      cartCountElements.forEach(el => {
        el.textContent = cart.item_count;
      });
    })
    .catch(error => console.error('Error updating cart count:', error));
}

/**
 * Muestra una notificación temporal
 */
function showNotification(message) {
  // Verificar si ya existe una notificación
  let notification = document.querySelector('.cart-notification');
  
  if (!notification) {
    notification = document.createElement('div');
    notification.className = 'cart-notification';
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: #4CAF50;
      color: white;
      padding: 15px 20px;
      border-radius: 4px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.2);
      z-index: 10000;
      animation: slideIn 0.3s ease;
    `;
    document.body.appendChild(notification);
  }
  
  notification.textContent = message;
  notification.style.display = 'block';
  
  setTimeout(() => {
    notification.style.animation = 'slideOut 0.3s ease';
    setTimeout(() => {
      notification.style.display = 'none';
    }, 300);
  }, 3000);
}

/**
 * Configura los controles de cantidad
 */
function setupQuantityControls(card) {
  const minusBtn = card.querySelector('.quantity-btn--minus');
  const plusBtn = card.querySelector('.quantity-btn--plus');
  const quantityInput = card.querySelector('.quantity-input');
  
  if (!minusBtn || !plusBtn || !quantityInput) return;
  
  // Botón disminuir
  minusBtn.addEventListener('click', function() {
    let currentValue = parseInt(quantityInput.value) || 1;
    if (currentValue > 1) {
      quantityInput.value = currentValue - 1;
      updateTotalPrice(card);
    }
  });
  
  // Botón aumentar
  plusBtn.addEventListener('click', function() {
    let currentValue = parseInt(quantityInput.value) || 1;
    quantityInput.value = currentValue + 1;
    updateTotalPrice(card);
  });
  
  // Input directo
  quantityInput.addEventListener('change', function() {
    let value = parseInt(this.value) || 1;
    if (value < 1) value = 1;
    this.value = value;
    updateTotalPrice(card);
  });
}

/**
 * Configura el selector de variantes
 */
function setupVariantSelector(card) {
  const variantSelectors = card.querySelectorAll('.trending-products__select');
  
  if (!variantSelectors.length) return;
  
  variantSelectors.forEach(variantSelector => {
    variantSelector.addEventListener('change', function() {
      const selectedOption = this.options[this.selectedIndex];
      const price = selectedOption.getAttribute('data-price');
      const comparePrice = selectedOption.getAttribute('data-compare-price');
      const isAvailable = selectedOption.getAttribute('data-available') === 'true';
      const variantId = selectedOption.value;
      
      // Sincronizar ambos selectores (vertical y horizontal)
      const allSelectors = card.querySelectorAll('.trending-products__select');
      allSelectors.forEach(select => {
        if (select !== this) {
          select.value = variantId;
        }
      });
      
      // Actualizar precio unitario en layout horizontal
      const unitPriceEl = card.querySelector('.unit-price');
      if (unitPriceEl && price) {
        unitPriceEl.textContent = formatMoney(parseFloat(price));
      }
      
      // Actualizar precios en layout vertical
      const priceEl = card.querySelector('[data-price-default]');
      const comparePriceEl = card.querySelector('[data-compare-price-default]');
      
      if (priceEl && price) {
        priceEl.textContent = formatMoney(parseFloat(price));
      }
      
      if (comparePrice && comparePriceEl) {
        comparePriceEl.textContent = formatMoney(parseFloat(comparePrice));
        comparePriceEl.style.display = 'inline';
      } else if (comparePriceEl) {
        comparePriceEl.style.display = 'none';
      }
      
      // Actualizar precio total en layout horizontal
      updateTotalPrice(card);
      
      // Actualizar variant-id en todos los botones
      const allButtons = card.querySelectorAll('[data-variant-id]');
      allButtons.forEach(btn => {
        btn.setAttribute('data-variant-id', variantId);
        btn.disabled = !isAvailable;
      });
    });
  });
}

/**
 * Actualiza el precio total basado en cantidad
 */
function updateTotalPrice(card) {
  const quantityInput = card.querySelector('.quantity-input');
  const unitPriceEl = card.querySelector('.unit-price');
  const totalPriceEl = card.querySelector('.total-price');
  
  if (!quantityInput || !unitPriceEl || !totalPriceEl) return;
  
  const quantity = parseInt(quantityInput.value) || 1;
  const unitPriceText = unitPriceEl.textContent;
  
  // Extraer el valor numérico del precio
  const unitPrice = parseFloat(unitPriceText.replace(/[^0-9.]/g, ''));
  
  if (!isNaN(unitPrice)) {
    const totalPrice = unitPrice * quantity;
    totalPriceEl.textContent = formatMoney(totalPrice);
  }
}


/**
 * Formatea el precio como moneda sin decimales
 */
function formatMoney(amount) {
  return new Intl.NumberFormat('es-DO', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

/**
 * Observer para detectar cambios en la clase del grid
 * Útil si la clase .product-grid--1-col se agrega/quita dinámicamente
 */
const gridObserver = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.attributeName === 'class') {
      const target = mutation.target;
      if (target.classList.contains('product-grid--1-col')) {
        // Reinicializar cards cuando cambia a layout horizontal
        initHorizontalCards();
      }
    }
  });
});

// Observar cambios en results-list
const resultsList = document.querySelector('results-list');
if (resultsList) {
  gridObserver.observe(resultsList, {
    attributes: true,
    attributeFilter: ['class']
  });
}